import React, { useState } from "react";
import { Row, Col, Input, Button } from "antd";
import MultipleChoice from "../../components/MultipleChoice";

function onSubmittion(e, goNextStep) {
  e.preventDefault();

  goNextStep({ step: "START_EVALUATION" });
}

const intl = {
  name: {
    en: "FULL NAME",
    dk: "FULDE NAVN"
  },
  age: {
    en: "AGE",
    dk: "ALDER"
  },
  education: {
    en: "Education level",
    dk: "Uddannelsesniveau"
  },
  leadershipExp: {
    en: "Leadership experience",
    dk: "Ledelseserfaring"
  },
  references: {
    en: "Number of direct references",
    dk: "Antal direkte referencer"
  },
  submitText: {
    en: "BEGIN SELF-EVALUTION",
    dk: "START SELVEVALUERING"
  }
};

function BeginInfoForm(props) {
  const [currentEmail, setEmail] = useState(
    props.user && props.user.email ? props.user.email : null
  );
  const [currentName, setName] = useState(
    props.user && props.user.name ? props.user.name : null
  );

  if (
    (props.user && props.user.email !== currentEmail) ||
    (props.user && props.user.name !== currentName)
  ) {
    setEmail(props.user.email);

    setName(props.user && props.user.name);

    props.updateEvaluation({
      email: props.user.email,
      fullName: props.user.name
    });
  }

  return (
    <form onSubmit={e => onSubmittion(e, props.updateEvaluation)}>
      <Row className="survey_content_container">
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Row gutter={16}>
            <Col md={12} style={{ marginBottom: "20px" }}>
              {!currentName ? (
                <Input
                  type="text"
                  name="name"
                  size="large"
                  placeholder={intl.name[props.language]}
                  onChange={e =>
                    props.updateEvaluation({
                      fullName: e.target.value,
                      type: props.type
                    })
                  }
                  style={{ textAlign: "center", color: "#1abc9c" }}
                  required
                />
              ) : (
                <div />
              )}
            </Col>
            <Col md={12} style={{ marginBottom: "20px" }}>
              {!currentEmail ? (
                <Input
                  type="email"
                  name="email"
                  size="large"
                  placeholder="E-MAIL"
                  onChange={e =>
                    props.updateEvaluation({ email: e.target.value })
                  }
                  style={{ textAlign: "center", color: "#1abc9c" }}
                  required
                />
              ) : (
                <div />
              )}
            </Col>
            <Col md={12} style={{ marginBottom: "20px" }}>
              <MultipleChoice
                id="experienceChoices"
                title={intl.age[props.language]}
                value={props.age}
                choices={[
                  { value: "<25", title: "<25" },
                  { value: "26-35", title: "26-35" },
                  { value: "36-45", title: "36-45" },
                  { value: ">45", title: ">45" }
                ]}
                onChange={e => props.updateEvaluation({ age: e.target.value })}
              />
            </Col>
            <Col md={12} style={{ marginBottom: "20px" }}>
              <MultipleChoice
                id="educationChoices"
                title={intl.education[props.language]}
                value={props.educationalLevel}
                choices={
                  props.language === "en"
                    ? [
                        { value: "highschool", title: "High school" },
                        { value: "graduate", title: "Graduate" },
                        { value: "phd", title: "Ph.D" },
                        { value: "postdoc", title: "Post Doc" },
                        { value: "other", title: "Other" }
                      ]
                    : [
                        { value: "gymnasial", title: "Gymnasial" },

                        { value: "bachelor", title: "Bachelor" },
                        { value: "kandidat", title: "Kandidat" },
                        { value: "phd", title: "Ph.D" },
                        { value: "postdoc", title: "Post Doc" },

                        { value: "andet", title: "Andet" }
                      ]
                }
                onChange={e =>
                  props.updateEvaluation({ educationalLevel: e.target.value })
                }
              />
            </Col>
            <Col md={12} style={{ marginBottom: "20px" }}>
              <MultipleChoice
                id="leadingChoices"
                title={intl.leadershipExp[props.language]}
                value={props.leadershipExp}
                choices={[
                  {
                    value: "<5",
                    title: props.language === "en" ? "<5 years" : "<5 år"
                  },
                  {
                    value: "5-10",
                    title: props.language === "en" ? "5-10 years" : "5-10 år"
                  },
                  {
                    value: "10+",
                    title: props.language === "en" ? "10+ years" : "10+ år"
                  }
                ]}
                onChange={e =>
                  props.updateEvaluation({ leadershipExp: e.target.value })
                }
              />
            </Col>
            <Col md={12} style={{ marginBottom: "20px" }}>
              <MultipleChoice
                id="ageChoices"
                title={intl.references[props.language]}
                value={props.numberOfReferences}
                choices={[
                  { value: "0-5", title: "0-5" },
                  { value: "6-12", title: "6-12" },
                  { value: "13-25", title: "13-25" },
                  { value: "25+", title: "25+" }
                ]}
                onChange={e => {
                  props.updateEvaluation({
                    numberOfReferences: e.target.value
                  });
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Button
            htmlType="submit"
            type="primary"
            size="large"
            style={{ padding: "0 30px" }}
          >
            {intl.submitText[props.language]}
          </Button>
        </Col>
      </Row>
    </form>
  );
}

export default BeginInfoForm;



// WEBPACK FOOTER //
// ./src/pages/Evaluation/BeginInfoForm.js